import { useEffect, useState } from 'react'

import { getEditDeadline } from '../lib/utils'

/**
 * 수량 변경 가능 시간 만료 여부.
 *
 * 변경 기한 = 신청일(registeredAt) 기준 익일 오전 11:00 (getEditDeadline 공용).
 * 진입 시점에 이미 기한이 지났으면 즉시 만료(true)로 시작하고,
 * 변경 화면에 머무는 동안 기한이 지나면 타이머로 만료 상태를 전환한다.
 */
export function useEditWindowExpiry(registeredAt: number[]): boolean {
  const deadline = getEditDeadline(registeredAt).getTime()
  const [isExpired, setIsExpired] = useState(() => Date.now() >= deadline)

  useEffect(() => {
    if (isExpired) return undefined

    const timer = setTimeout(() => setIsExpired(true), deadline - Date.now())
    return () => clearTimeout(timer)
  }, [deadline, isExpired])

  return isExpired
}
